export enum PaymentSystem {
  Visa = "Visa",
  Mastercard = "MasterCard",
}
